(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function injectMobileTightGapStyles() {
    if (document.getElementById('an-mobile-collection-tight-gap')) return;
    var style = document.createElement('style');
    style.id = 'an-mobile-collection-tight-gap';
    style.textContent = [
      '@media(max-width:860px){',
      '#anCollectionControls .an-collection-control-shell{gap:5px!important;}',
      '#anCollectionControls .an-collection-nav-row{gap:1px!important;column-gap:6px!important;row-gap:1px!important;margin-top:0!important;margin-bottom:0!important; padding:0 !important;}',
      '#anCollectionControls .an-collection-nav-row--nested{margin-top:0!important;}',
      '#anCollectionControls .an-collection-nav-row + .an-collection-nav-row{margin-top:0!important;}',
      '#anCollectionControls .an-collection-tool-row{margin-top:0!important;}',
      '}',
      '@media(max-width:420px){',
      '#anCollectionControls .an-collection-control-shell{gap:5px!important;}',
      '#anCollectionControls .an-collection-nav-row{gap:1px!important;column-gap:6px!important;row-gap:1px!important;margin-top:0!important;margin-bottom:0!important; padding:0 !important;}',
      '#anCollectionControls .an-collection-nav-row--nested{margin-top:0!important;}',
      '#anCollectionControls .an-collection-nav-row + .an-collection-nav-row{margin-top:0!important;}',
      '#anCollectionControls .an-collection-tool-row{margin-top:0!important;}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  function initCollectionFilterOverride() {
    injectMobileTightGapStyles();

    var controls = document.getElementById('anCollectionControls');
    if (!controls || controls.getAttribute('data-an-filter-overridden') === 'true') return;

    var shell = controls.querySelector('.an-collection-control-shell');
    var oldRow = shell && shell.querySelector('.an-collection-nav-row');
    if (!shell || !oldRow) return;

    controls.setAttribute('data-an-filter-overridden', 'true');

    var path = window.location.pathname || '';
    var tagPart = (path.match(/\/collections\/[^\/]+\/(.+)$/) || [])[1] || '';
    tagPart = decodeURIComponent(tagPart).toLowerCase();

    var active = {};
    oldRow.querySelectorAll('.an-nav-pill.active').forEach(function (pill) {
      active[(pill.textContent || '').trim().toLowerCase()] = true;
    });

    var profile = '';
    if (active.men || /(^|\+)for-him($|\+)/.test(tagPart)) profile = 'for-him';
    else if (active.women || /(^|\+)for-her($|\+)/.test(tagPart)) profile = 'for-her';
    else if (active.unisex || /(^|\+)unisex($|\+)/.test(tagPart)) profile = 'unisex';

    var source = '';
    if (active.arabian || active['middle eastern'] || /(^|\+)arabian($|\+)/.test(tagPart)) source = 'arabian';
    else if (active.designer || /(^|\+)designer($|\+)/.test(tagPart)) source = 'designer';

    function urlFor(nextProfile, nextSource) {
      var tags = [];
      if (nextProfile) tags.push(nextProfile);
      if (nextSource) tags.push(nextSource);
      return '/collections/all' + (tags.length ? '/' + tags.join('+') : '');
    }

    function pill(label, href, isActive) {
      var a = document.createElement('a');
      a.href = href;
      a.className = 'an-nav-pill' + (isActive ? ' active' : '');
      a.textContent = label;
      return a;
    }

    oldRow.innerHTML = '';
    oldRow.classList.add('an-collection-nav-row--primary');
    oldRow.appendChild(pill('All', urlFor('', source), !profile));
    oldRow.appendChild(pill('Men', urlFor('for-him', source), profile === 'for-him'));
    oldRow.appendChild(pill('Women', urlFor('for-her', source), profile === 'for-her'));
    oldRow.appendChild(pill('Unisex', urlFor('unisex', source), profile === 'unisex'));

    var nestedRow = document.createElement('div');
    nestedRow.className = 'an-collection-nav-row an-collection-nav-row--nested';
    nestedRow.appendChild(pill('Middle Eastern', urlFor(profile, source === 'arabian' ? '' : 'arabian'), source === 'arabian'));
    nestedRow.appendChild(pill('Designer', urlFor(profile, source === 'designer' ? '' : 'designer'), source === 'designer'));
    shell.insertBefore(nestedRow, oldRow.nextSibling);
  }

  ready(initCollectionFilterOverride);
})();

(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  var banners = {
    '/collections/all': {
      desktop: 'https://cdn.shopify.com/s/files/1/0985/0785/0027/files/afternote-all-fragrances-desktop.png?v=1783709154',
      mobile: 'https://cdn.shopify.com/s/files/1/0985/0785/0027/files/afternote-all-fragrances-mobile.png?v=1783709186'
    },
    '/collections/all/for-her': {
      desktop: 'https://cdn.shopify.com/s/files/1/0985/0785/0027/files/afternote-collection-for-her-desktop.webp?v=1783708004',
      mobile: 'https://cdn.shopify.com/s/files/1/0985/0785/0027/files/afternote-collection-for-her-mobile.webp?v=1783708028'
    },
    '/collections/all/for-him': {
      desktop: 'https://cdn.shopify.com/s/files/1/0985/0785/0027/files/afternote-collection-for-him-desktop.webp?v=1783708052',
      mobile: 'https://cdn.shopify.com/s/files/1/0985/0785/0027/files/afternote-collection-for-him-mobile.webp?v=1783708078'
    },
    '/collections/all/unisex': {
      desktop: 'https://cdn.shopify.com/s/files/1/0985/0785/0027/files/afternote-collection-unisex-desktop.webp?v=1783708102',
      mobile: 'https://cdn.shopify.com/s/files/1/0985/0785/0027/files/afternote-collection-unisex-mobile.webp?v=1783708127'
    },
    '/collections/all/arabian': {
      desktop: 'https://cdn.shopify.com/s/files/1/0985/0785/0027/files/afternote-collection-middle-eastern-desktop.webp?v=1783708151',
      mobile: 'https://cdn.shopify.com/s/files/1/0985/0785/0027/files/afternote-collection-middle-eastern-mobile.webp?v=1783708173'
    },
    '/collections/all/designer': {
      desktop: 'https://cdn.shopify.com/s/files/1/0985/0785/0027/files/afternote-collection-designer-desktop.webp?v=1783708193',
      mobile: 'https://cdn.shopify.com/s/files/1/0985/0785/0027/files/afternote-collection-designer-mobile.webp?v=1783708216'
    }
  };

  function injectBannerStyles() {
    if (document.getElementById('an-custom-collection-banner-styles')) return;
    var style = document.createElement('style');
    style.id = 'an-custom-collection-banner-styles';
    style.textContent = [
      '.an-collection-hero.an-has-custom-banner:before{display:none!important;}',
      '.an-collection-hero.an-has-custom-banner>.an-collection-photo:not(.an-custom-collection-photo){display:none!important;}',
      '.an-collection-hero .an-custom-collection-photo{position:absolute!important;inset:0!important;z-index:0!important;background-size:cover!important;background-repeat:no-repeat!important;background-position:center center!important;transform:scale(1.02)!important;}',
      '.an-collection-hero .an-custom-collection-photo--mobile{display:none!important;}',
      '@media(max-width:860px){.an-collection-hero .an-custom-collection-photo--desktop{display:none!important}.an-collection-hero .an-custom-collection-photo--mobile{display:block!important}}'
    ].join('');
    document.head.appendChild(style);
  }

  function applyCollectionBanner() {
    var path;
    try {
      path = decodeURIComponent(window.location.pathname || '').replace(/\/+$/, '').toLowerCase();
    } catch (error) {
      path = (window.location.pathname || '').replace(/\/+$/, '').toLowerCase();
    }

    var banner = banners[path];
    if (!banner) return;

    var hero = document.querySelector('.an-collection-hero');
    if (!hero || hero.getAttribute('data-an-custom-banner') === 'true') return;

    injectBannerStyles();
    hero.setAttribute('data-an-custom-banner', 'true');
    hero.classList.add('an-has-custom-banner');

    var desktop = document.createElement('div');
    desktop.className = 'an-collection-photo an-custom-collection-photo an-custom-collection-photo--desktop';
    desktop.setAttribute('role', 'img');
    desktop.setAttribute('aria-label', 'Collection banner');
    desktop.style.backgroundImage = 'url("' + banner.desktop + '")';

    var mobile = document.createElement('div');
    mobile.className = 'an-collection-photo an-custom-collection-photo an-custom-collection-photo--mobile';
    mobile.setAttribute('role', 'img');
    mobile.setAttribute('aria-label', 'Collection banner');
    mobile.style.backgroundImage = 'url("' + banner.mobile + '")';

    var scrim = hero.querySelector('.an-collection-scrim');
    if (scrim) {
      hero.insertBefore(desktop, scrim);
      hero.insertBefore(mobile, scrim);
    } else {
      hero.insertBefore(mobile, hero.firstChild);
      hero.insertBefore(desktop, hero.firstChild);
    }
  }

  ready(applyCollectionBanner);
  document.addEventListener('shopify:section:load', applyCollectionBanner);
})();

(function () {
  if (document.getElementById('an-remove-collection-art')) return;
  var style = document.createElement('style');
  style.id = 'an-remove-collection-art';
  style.textContent = '.an-collection-art{display:none!important;}';
  document.head.appendChild(style);
})();
